import React from 'react';
import { Status } from '../../../ui';
import moment from 'moment';
import i18n from 'i18next';
import { ReactComponent as Cart } from '../../../../picture/cart-blue.svg'
import { ReactComponent as Lock } from '../../../../picture/lock-blue.svg'
import { useTranslation } from "react-i18next";
import { APIAction } from '../../../order-menu/api-action/api-action';
import { Button } from '../../../ui';
import Chip from './chip';
import formattedAmount from './utils';
import './style/header.css';


function HeaderItem({title, value, className}) {
    return (
        <div className='wz-header-item'>
            <div className='wz-header-item-title'>{title}</div>
            <div className={`wz-header-item-value ${className}`}>{value}</div>
        </div>
    )
}

export default function TicketHeader({data, state, cta = false, actions = [], onAction = () => {}}) {
    const { t } = useTranslation();
    moment.locale(i18n.language);

    const activeStatus = React.useMemo(() => {
        if (data.status === 'active' || data.status === "free" || data.status === "paid") {
            return "valid"
        }
        return data.status
    },[data])

    const statusColor = React.useMemo(() => {
        if (activeStatus === "valid") {
            return 'green';
        } else if (activeStatus === 'reserved') {
            return 'orange';
        } else {
            return 'red';
        }
    }, [activeStatus]);

    const resaleStatusText = React.useMemo(() => {
        if(['on_sale', 'sale_in_progress', 'sale_in_progress_cancel_if_not_sold'].includes(data.resale_status)) {
            return data.resale_status;
        } else {
            return 'sold';
        }
    }, [data]);

    const moderationStatusColor = React.useMemo(() => {
        if (data.moderation_status == null) {
            return ""
        }
        switch (data.moderation_status.stage) {
            case 'validated':
                return 'green';
            case 'incomplete':
                return 'grey';
            case 'external':
                return 'blue';
            case 'declined':
                return 'red';
            default:
                return 'blue'
    }}, [data])

    return (
        <div className='wz-header'>
            <div className='wz-header-infos'>
                <div>
                    <div className='wz-header-name-and-status'>
                        <div className='wz-header-name'>{data.first_name} {data.last_name.toUpperCase()}</div>
                        <Status color={statusColor} text={t(`widget.resale.header.status.${activeStatus}`)}/>
                    </div>
                    <div className='wz-header-items'>
                        <HeaderItem title={t('widget.resale.header.event')} value={data.event_name}/>
                        {data.event_date && 
                        <div className='wz-neo-card-event-date'>
                            <HeaderItem title={t('widget.resale.header.event_date')} value={moment(data.event_date).format('DD/MM/YYYY HH:mm')}/>
                        </div>
                        }
                        {data.moderation_status &&
                            <HeaderItem title={t('widget.resale.header.moderation_status')} value={<Status color={moderationStatusColor} text={data.moderation_status.public_name}/>}/>
                        }
                    </div>
                </div>
                <div className='wz-header-chip-and-lock-container'>
                    {['sold', 'on_sale', 'sale_in_progress', 'sale_in_progress_cancel_if_not_sold'].includes(data.resale_status) &&
                        <div className='wz-header-chip'>
                            <Chip status={data.resale_status} icon={<Cart className='wz-cart-icon'/>} text={t(`widget.resale.header.${resaleStatusText}`)}/>
                        </div>
                    }
                    {
                        !cta && state?.is_private_resale && 
                        <div className='wz-header-lock'>
                            <Lock className='wz-lock-icon'/>
                        </div>
                    }
                </div>
            </div>
            <div className='wz-header-content'>
                <div className='wz-header-items'>
                    <div className='wz-neo-card-ticket-price'>
                        <HeaderItem title={t('widget.resale.header.ticket_price')} value={formattedAmount(data.paid_price, data.currency)} className='wz-header-total-price'/>
                    </div>
                    <HeaderItem title={t('widget.resale.header.rate_name')} value={data.rate_name}/>
                    {Object.keys(data).includes('barcode') && data.barcode ? 
                        <div className='wz-neo-card-barcode'>
                            <HeaderItem title={t('widget.resale.header.barcode')} value={data.barcode}/>
                        </div>
                        :
                        null
                }
                    
                </div>
            </div>
            {cta && (
                <div className="wz-neo-card-footer">
                    <APIAction actions={actions} name="TicketMenuStep">
                        <Button
                            className="wz-header-cta"
                            onClick={onAction}
                            disabled={data.status === 'removed'}
                            label={t('widget.card.button')}
                        />
                    </APIAction>
                </div>
            )}
        </div>
    )
}
